import _ from 'underscore'
import env from '@polleverywhere/core/lib/env'
import { deepDefaults } from '@polleverywhere/core/lib/util.js'
import { bindings } from '../../'
import { joinInstructionsSettings } from './join_instructions_settings'

function getJoinInstructionsUrl () {
  return env
    .get('api_url')
    .path('join_instructions')
    .protocol(env.get('secure_protocol'))
    .toString()
}

function getJoinInstructionsVizUrl (options = {}) {
  _.defaults(options, {
    query: {}
  })

  const uri = env
    .get('viz_url')
    .path('join_instructions')
    .protocol(env.get('secure_protocol'))

  uri.query(options.query)

  return uri.toString()
}

function getJoinInstructionsPlaceholderUrl (options = {}) {
  deepDefaults(options, {
    placeholderFormat: 'tiny',
    aspectRatio: 1.33,
    joinQuery: {
      display: 'placeholder_steps'
    }
  })

  const url = getJoinInstructionsVizUrl({
    query: options.joinQuery
  })

  const width =
    options.aspectRatio >= 1.33 && options.aspectRatio < 1.34 ? 1200 : 1600 // 4:3 aspect ratio comes out to a width/height ratio of 1.33...

  return env
    .get('slide_server_url')
    .path('placeholder_cdn_url')
    .query({
      url: url,
      width,
      height: '900',
      brand: 'polleverywhere',
      hide: 'qr_code',
      format: options.placeholderFormat
    })
    .toString()
}

function createSlideDataForJoinInstructions (options = {}) {
  const displayParams = ['placeholder_steps']
  if (options.web_enabled) { displayParams.push('web') }
  if (options.sms_enabled) { displayParams.push('sms') }
  return {
    title: 'Join instructions',
    activityUrl: getJoinInstructionsUrl(),
    placeholderUrl: getJoinInstructionsPlaceholderUrl({
      aspectRatio:
        bindings.masterSlideWidth() /
        bindings.masterSlideHeight(),
      joinQuery: {
        display: displayParams.join()
      }
    })
  }
}

export async function getSlideDataForJoinInstructionsFromUrls (urlsInDeck = []) {
  const settings = await joinInstructionsSettings({
    urls: urlsInDeck
  })

  return createSlideDataForJoinInstructions({
    web_enabled: settings.web_enabled,
    sms_enabled: settings.sms_enabled
  })
}
